import { render, staticRenderFns } from "./MedicineSummaryPurchase.vue?vue&type=template&id=cc72f678"
import script from "./MedicineSummaryPurchase.vue?vue&type=script&lang=js"
export * from "./MedicineSummaryPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports